// Zpracovat odeslání formuláře

import * as Sentry from '@sentry/browser';
import { FlashMessage, SVGLoader } from '@components';
import { prepareFormData } from '@utils/form';
import * as api from './forumApi';
import * as els from './forumElements';
import { addNewBadWords as addNewWord } from './forumBadWordsUtils';

export interface ResponseSuccess {
  status: boolean;
}

export const CLASS_BADWORDS_LIST = 'forum__badwords-list';

export const submitBadWords = () => {
  // Uložit změny
  const form = els.formBadWords();

  if (form)
    // Po odeslání formuláře
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const { threadId } = form.dataset;
      const textarea: HTMLTextAreaElement | null = form.querySelector('textarea');
      const buttonSubmit: HTMLButtonElement | null = form.querySelector('button');
      const badWordsList: NodeListOf<HTMLButtonElement> | null =
        document.querySelectorAll('[data-badwords-item]');

      if (!badWordsList || !threadId || !textarea || !buttonSubmit) {
        Sentry.captureException('forumBadWordsSubmit: some UI elements are missing');
        throw new Error('updateBadWords: some UI elements are missing');
      }

      // Přidat loader
      const svgLoader = SVGLoader.create({ addTo: buttonSubmit, size: 20 });

      // Připravit data
      const requestData = prepareFormData({
        badwords: addNewWord(badWordsList, textarea.value),
        ajax: '1',
      });

      // Odeslat
      fetch(api.badWords(threadId), {
        method: 'POST',
        body: requestData,
      })
        .then((response) => response.json())
        .then(async (data: ResponseSuccess) => {
          switch (data.status) {
            case true:
              // Vynulovat vstup
              textarea.value = '';

              // Informovat uživatele
              await FlashMessage({ msg: 'Slovník byl aktualizován.', type: 'success' });

              window.location.reload();
              break;
            default:
              throw new Error('Server nevrátil odpověď.');
          }
        })
        .catch(async (errMsg: string) => {
          Sentry.captureException(errMsg);
          await FlashMessage({
            msg: `Akci se nepodařilo provést. ${errMsg}`,
            type: 'error',
          });
          svgLoader.remove();
        });
    });
};
